import React from 'react';
import Slider from 'react-slick';
import TestimonialItem from './TestimonialItem.js';
import {useTranslation } from "react-i18next";
import TestimonialItem2 from './TestimonialItem2.js';
import TestimonialItem3 from './TestimonialItem3.js';


function Testimonials() {
    const { t, i18n } = useTranslation();

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1      
    };
    return (     
      <section id="testimonials" className="testimonials section-bg">        
        <div className="container">   

            <div className="section-title">
              <h2>{t("testimonials")}</h2>
              <p>{t("testimonials-h")}</p>
            </div>

            <Slider {...settings}>
              {/* First slide */}
              <div className="row d-flex">
                <TestimonialItem source="Google review" date="Jun, 2021" text={t("testimonial-1")}/>                         
                <TestimonialItem3 link={t("click-article")} source="Nieuwsblad.be" date="Jun 18, 2021" text={t("testimonial-7")}/>                         
                
              </div>
              <div className="row d-flex">
                <TestimonialItem2 source="Google review" date="Jun, 2021" text={t("testimonial-2")}/>                  
              </div>
              {/* Second slide */}
              <div className="row d-flex">
                <TestimonialItem source="Instagram post" date="Sep 5, 2021" text={t("testimonial-3")}/>
                <TestimonialItem source="Instagram post" date="Aug 29, 2021" text={t("testimonial-4")}/>
              </div>  
              {/* Third slide */}
              <div className="row d-flex">
                <TestimonialItem source="Google review" date="Aug, 2021" text={t("testimonial-5")}/>
                <TestimonialItem source="Google review" date="Aug, 2021" text={t("testimonial-6")}/>                
              </div>    
            </Slider>            
        </div>

        <div className="center pt-5">
          <a className="main-btn" target="_blank" rel="noreferrer" href="https://www.google.com/search?hl=en-BE&gl=be&q=Old+Tbilisi,+Nieuwstraat+20,+1730+Asse&ludocid=3911857777478912669&lsig=AB86z5Uuhg4bYWu02xHLGLNOMZSo#lrd=0x47c3bf6ba3d7e179:0x3649b5ec367aca9d,3">  {t("write-review")} <i className="fas fa-pencil-alt"></i></a>
        </div>

      </section>
    )
}

export default Testimonials;
